import vuetify from "./vuetify";

export function registerPlugins(app) {
  app.use(vuetify);
}
